export const SIGMAI_LOGO_SRC = "/sigmai-logo-light.png"
export const SIGMAI_LOGO_DARK_SRC = "/sigmai-logo-dark.png"
export const SIGMAI_FAVICON_SRC = "/favicon.png"
export const SIGMAI_THEME_COLOR = "#1a2540"
